<div class="content-blk">
  <div class="container">
    <h5 class="page-title">
      Request A Color
    </h5>
    <p class="add-product-dashboard">
      You can now request the products and its colors that you want to add in the catalogue list, If we have any further questions about this particular request we'll reach out to you directly.
      <strong>- Team Merchloop</strong>
    </p>
    <form [formGroup]="requestColorForm" #formDirective="ngForm" (submit)="fn_SubmitRequest(formDirective)" autocomplete="off">
      <div class="mat-crd-ui report-bug">
        <mat-card class="pad-16">
          <mat-card-content>
            <div class="example-form">
              <div class="row">
                <div class="col-sm-6">
                  <mat-form-field class="example-full-width">
                    <mat-label>Product Name/Style#</mat-label>
                    <input matInput formControlName="productTitle" required>
                    <mat-error *ngIf="f.productTitle.touched && f.productTitle.invalid && f.productTitle.pristine">
                      <strong>Required</strong>
                    </mat-error>
                    <mat-error *ngIf="!f.productTitle.valid && (f.productTitle.touched && f.productTitle.dirty)">
                      <strong>Required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-6">
                  <mat-form-field class="example-full-width">
                    <mat-label>Product Color</mat-label>
                    <input matInput formControlName="productColor" required>
                    <mat-error *ngIf="f.productColor.touched && f.productColor.invalid && f.productColor.pristine">
                      <strong>Required</strong>
                    </mat-error>
                    <mat-error *ngIf="!f.productColor.valid && (f.productColor.touched && f.productColor.dirty)">
                      <strong>Required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <mat-form-field class="example-full-width">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description" rows="6" required></textarea>
                <mat-hint class="hint">Detailed description of the product that you are requesting.</mat-hint>
                <mat-error *ngIf="f.description.touched && f.description.invalid && f.description.pristine">
                  <strong>Required</strong>
                </mat-error>
                <mat-error *ngIf="!f.description.valid && (f.description.touched && f.description.dirty)">
                  <strong>Required</strong>
                </mat-error>
              </mat-form-field>            
            </div>
          </mat-card-content>

          <div class="text-center sv-up-dt">
            <button class="mat-btn btn-danger" mat-raised-button cdkFocusInitial [disabled]="requestColorForm.invalid">
              Submit
            </button>
          </div>
        </mat-card>
      </div>
    </form>
  </div>
</div>
